export class INDRASeatmap {
	cabins: INDRACabin[];
	currency: any;
}

export type INDRACabinClass = 'economy' | 'business';

export interface INDRACabin {
	/**
	* Y - Coach Economy
	* W - Coach Economy Premium
	* T -Coach Economy Discounted
	* S- Standard Class
	* C - Business Class
	* F - First Class
   	*/
	location: 'Y' | 'W' | 'T' | 'S' | 'C' | 'F';
	seatColumns: INDRASeatColumn[];
	rows: INDRACabinRow[];
	facilities: INDRAFacility[];
}

export class INDRASeatColumn {
	index: string;
	status: 'WINDOW' | 'CENTER' | 'AISLE';
	class?: string;
}

export const SEAT_COLUMN_STATUS_WINDOW = 'WINDOW';
export const SEAT_COLUMN_STATUS_CENTER = 'CENTER';
export const SEAT_COLUMN_STATUS_AISLE = 'AISLE';

export class INDRANewSeats {
	passengerIndex: number;
	seat: string;
	price: number;
	type?: string;
	points?: number;
	seatDescription?: string;
	seatType?: string;
}

export class INDRAPlaneWing {
	startRow: number;
	rowsCount: number;
}

export interface INDRACabinRow {
	index: number;
	wing: boolean;
	empty: boolean;
	seatsByCode: INDRAPlaneSeat[];
}

export interface INDRAPlaneSeat {
	seatCode: string;
	// row: string;
	// column: string;
	available: boolean;
	missing: boolean;
	extraLegSpace: boolean;
	exit: boolean;
	chargeable: boolean;
	allowedInfant: boolean;
	allowedMedical: boolean;
	allowedUnnacompaniedMinor: boolean;
	suitableUnnacompaniedMinor: boolean;
	suitableChildren: boolean;
	handicappedFacilities: boolean;
	allowedBassinet: boolean;
	preferredSeat: boolean;
	prices: any[];
	seatDescription?: string;
	characteristics: string[];
	tableLeft?: boolean;
	tableRight?: boolean;
	rotateLeft?: boolean;
	rotateRight?: boolean;
	class?: boolean;
	empty?: boolean;
	type?: string;
}

export interface INDRAFacility {
	rowLocation: string;
	// G - Galley, LA - Lavatory,, CL - Closet, E - Emergency Exit, D - Exit Door
	type: 'G' | 'LA' | 'CL' | 'E' | 'D';
	location: string;
}
